<template>
  <div class="user-switcher">
    <v-combobox
      v-model="mentee"
      label="Mentee"
      :items="managedUsers"
      @change="switchUser"
    ></v-combobox>
  </div>
</template>

<script>
import User from "@/lib/user"
import { mapState } from "vuex"
import { UsersAPI } from "@/lib/api"
import { userType } from "@/lib/enums"

export default {
  data: function() {
    return {
      managedUsers: []
    }
  },
  computed: {
    mentee: {
      get() {
        if (this.$store.getters["globals/getMenteeName"]) {
          return {
            value: this.$store.getters["globals/getMenteeId"],
            text: this.$store.getters["globals/getMenteeName"]
          }
        } else {
          let id = this.$route.params.id
          let obj = this.managedUsers.find(el => el.value == id)
          if (id == 0) {
            obj = this.managedUsers[0]
          }

          return obj
        }
      },
      set(obj) {
        // if (obj) {
        this.$store.commit("globals/setMenteeId", obj.value)
        this.$store.commit("globals/setMenteeName", obj.text)
        // }
      }
    }
  },
  methods: {
    getManagedUsers: function() {
      UsersAPI.list({ disabled: false }).then(response => {
        let membersOnly = response.filter(
          el => !!(el.user_type & userType.MEMBER)
        )
        this.managedUsers = membersOnly.map(el => {
          return { text: `${el.first_name} ${el.last_name}`, value: el.id }
        })

        if (
          this.$store.getters["globals/getMenteeId"] == 0 &&
          (this.$route.params.id == 0 || this.$route.params.id === undefined)
        ) {
          this.mentee = this.managedUsers[0]
        }
      })
    },
    switchUser: function() {
      let currentRouteName = this.$route.name
      if (this.$route.params.id) {
        this.$router.push({
          name: currentRouteName,
          params: { id: this.mentee.value }
        })
      }
    }
  },
  created() {
    this.getManagedUsers()
  }
}
</script>

<style lang="scss" scoped>
.user-switcher {
  margin: 20px;
}
</style>
